import Markdown from 'react-markdown'

import type { EnumDefinition } from '../../uiModels/enumLiterals/types'
import { EnumNameCell } from './EnumNameCell'

type Props = {
  data: EnumDefinition
  column: number
  row?: number
}

export const EnumRowCell = ({ data, column }: Props) => {
  switch (column) {
    case 0:
      return <EnumNameCell data={data} />
    case 1:
      return null
    case 2:
      return (
        <div className="flex size-full items-center p-2">
          <Markdown>
            {data.internalOperation?.entity?.description ?? '\\-'}
          </Markdown>
        </div>
      )
    default:
      throw new Error(
        `Invalid table column. No data available for column ${column}`,
      )
  }
}
